import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** ID。CSSの指定に使用されている */
  id?: string;
  /** モーダルダイアログを表示するか否か */
  visible?: boolean;
  /** 背景の種類 */
  backgroundType?: 'background';
  /** 背景をクリック時のCallback */
  onClickBackground: (e: React.MouseEvent) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * ポップアップコンポーネント
 */
export const Popup: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  id = 'popup',
  visible,
  backgroundType = 'background',
  onClickBackground,
  className,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  return (
    <Element
      {...props}
      id={id}
      className={className}
      data-test={dataTest}
      style={visible ? {} : { display: 'none' }}
    >
      <Background
        onClick={onClickBackground}
        data-test={`${dataTest}-background`}
        className={backgroundType}
      />
      {props.children}
    </Element>
  );
};
Popup.displayName = 'Popup';

/**
 * ポップアップコンポーネントに載せる背景のコンポーネント
 */
const Background: WrappedFC<
  typeof DEFAULT_COMPONENT,
  { onClick: (e: React.MouseEvent) => void }
> = ({ className, element: Element = DEFAULT_COMPONENT, ...props }) => {
  return (
    <Element {...props} className={className}>
      {props.children}
    </Element>
  );
};
Background.displayName = 'Background';
